import { defineStore, storeToRefs } from "pinia";
import api from "@/services/api";
import ILabelPrinter from "@/models/responses/ILabelPrinter";
import { useSessionStore } from "@/stores/session.store.ts";
import ILabelPrinterUpsertRequest from "@/models/requests/ILabelPrinterUpsertRequest";
import LabelPrinter from "@/models/frontend/LabelPrinter";
import { useTenantsStore } from "./tenants.store";
import { useSitesStore } from "./sites.store";

export const useLabelPrintersStore = defineStore("labelPrinters", {
  state: () => ({
    error: "" as any,
    data: [] as LabelPrinter[],
    loadedSiteId: 0,
  }),
  actions: {
    async fetchAll(force = false) {
      const sessionStore = useSessionStore();
      const { selectedSiteId } = storeToRefs(sessionStore);

      if (!force && this.loadedSiteId === selectedSiteId.value) return;

      this.error = "";
      await api
        .get<ILabelPrinter[]>(`v1.0/label-printers`, {
          params: {
            siteId: selectedSiteId.value,
          }
        })
        .then((response) => {
          this.data = response.data.map((printer) => this.mapToFrontend(printer));
          this.loadedSiteId = selectedSiteId.value;
        })
        .catch((error) => (this.error = error));
    },
    async create(printer: ILabelPrinterUpsertRequest) {
      this.error = "";
      await api.post(`v1.0/label-printers`, printer)
        .catch((error) => (this.error = error));
    },
    async update(printerId: number, printer: ILabelPrinterUpsertRequest) {
      this.error = "";
      await api.put(`v1.0/label-printers/${printerId}`, printer)
        .catch((error) => (this.error = error));
    },
    async delete(id: number) {
      this.error = "";
      await api.delete(`v1.0/label-printers/${id}`)
        .catch((error) => (this.error = error));
    },
    mapToFrontend(printer: ILabelPrinter) {
      const tenant = useTenantsStore().getById(printer.tenantId);
      const site = useSitesStore().getById(printer.siteId);
      return new LabelPrinter(
        printer.id,
        tenant,
        site,
        printer.code,
        printer.address,
      );
    },
  },
  getters: {
    getAll:
      (state) => (): LabelPrinter[] => {
        return state.data;
      },
    getById:
      (state) => (id: number): LabelPrinter => {
        return <LabelPrinter>state.data.find((printer) => printer.id === id);
      },
  }
});
